import { TableRow } from '@src/design-system/table';
import { useTiclickTableContext } from './context/ticlick-table-context-hook';
import { Skeleton } from '@src/design-system/skeleton';
import { getPinningStyles } from './styles';
import { cn } from '@src/design-system/helpers';

export const TiclickTableSkeleton = ({
  showHeaders = true,
  colCount = 10,
}: {
  showHeaders?: boolean;
  colCount?: number;
}) => {
  const { table } = useTiclickTableContext();
  const columns = showHeaders
    ? table.getAllLeafColumns().filter((c) => c.getIsVisible())
    : [];
  return Array.from({ length: 10 }).map((_, index) => (
    <TableRow
      key={index}
      className='odd:bg-primary-50 h-[64px] data-[state=selected]:border-b border-pale-border'
    >
      {(showHeaders ? columns : Array.from({ length: colCount })).map(
        (col, idx) => {
          const column = col as (typeof columns)[number] | undefined;
          const isPinned = column?.getIsPinned();
          const isLastLeftPinned =
            isPinned === 'left' && column?.getIsLastColumn('left');
          const isFirstRightPinned =
            isPinned === 'right' && column?.getIsFirstColumn('right');
          return (
            <td
              key={column?.id ?? idx}
              className={cn(
                'p-2',
                '[&[data-pinned][data-last-col]]:border-pale-border data-pinned:backdrop-blur-lg [&[data-pinned=left][data-last-col=left]]:border-r [&[data-pinned=right][data-last-col=right]]:border-l'
              )}
              style={{
                ...(column ? getPinningStyles(column) : {}),
                width: column
                  ? undefined
                  : `calc(var(--col-${idx}-size) * 1px)`,
              }}
              data-pinned={isPinned || undefined}
              data-last-col={
                isLastLeftPinned
                  ? 'left'
                  : isFirstRightPinned
                    ? 'right'
                    : undefined
              }
            >
              <Skeleton className='h-4 bg-gray-100 rounded w-3/4' />
            </td>
          );
        }
      )}
    </TableRow>
  ));
};
